// extracted by mini-css-extract-plugin
export var numberInputContainer = "_72-0";
export var startPickingButton = "_72-1";